const InfoPaxMonetary = (state) => state.InfoPaxMonetary

export default {
  InfoPaxMonetary
}
